import { useCallback, useRef } from "react";
import { isFunction } from "@cayuse/shared-react.utils.type-checks";

export const useDebounceCallback = (callback, delayInMs = 300) => {
	let timeout = useRef(-1);

	return useCallback((...args) => {
		clearTimeout(timeout?.current);

		if (isFunction(callback)) {
			timeout.current = setTimeout(() => callback(...args), delayInMs);
		}
	}, [ callback, delayInMs ]);
};

export default useDebounceCallback;